/**
 * VÉRAULT Portal — Motion variants
 * Calm, editorial, ~200-400ms ease curves. Subtle, never showy.
 */
import { cubicBezier } from "framer-motion";

// Public-site-feel easing: gentle, never bouncy
export const ease = cubicBezier(0.22, 0.61, 0.36, 1);

export const fadeInUp = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.45, ease } },
  exit: { opacity: 0, y: -4, transition: { duration: 0.2, ease } },
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.5, ease } },
  exit: { opacity: 0, transition: { duration: 0.2, ease } },
};

export const stagger = {
  animate: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
};

export const hairline = {
  initial: { scaleX: 0, opacity: 0 },
  animate: { scaleX: 1, opacity: 1, transition: { duration: 0.7, ease } },
};
